export function testCZechBirthNumber(x: string, age?: number) {
    if (!age) age = 0;
    try {
        if (x.length == 0) return true;
        if (x.length > 10) return false;
        if (x.length < 9) return false;
        const isNumeric = /^\d+$/.test(x);
        if (!isNumeric) return false;
        let year = parseInt(x.substr(0, 2), 10);
        let month = parseInt(x.substr(2, 2), 10);
        const day = parseInt(x.substr(4, 2), 10);
        // extension part is not used in validation but kept for clarity
        // const ext = parseInt(x.substr(6, 3), 10);
        // SP throws error on 9 digit birthnumbers older than 1923.
        if (x.length == 9 && year < 24) return false;
        if (x.length == 9 && year < 54) return true;
        let c = 0;
        if (x.length == 10) c = parseInt(x.substr(9, 1));
        let m = parseInt(x.substr(0, 9)) % 11;
        if (m == 10) m = 0;
        if (m != c) return false;
        year += year < 54 ? 2000 : 1900;
        if (month > 70 && year > 2003) month -= 70;
        else if (month > 50) month -= 50;
        else if (month > 20 && year > 2003) month -= 20;
        const d = new Date();
        if (year + age > d.getFullYear()) return false;
        if (month == 0) return false;
        if (month > 12) return false;
        if (day == 0) return false;
        if (day > 31) return false;
    } catch (e) {
        return false;
    }
    return true;
}
